import { useEffect, useState } from "react";
import { db } from "./Firebase";
import Navbar from "./Navbar";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import PRODUCTS_DATA from "./Productsdata";

export default function Products() {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const navi = useNavigate();

    const [filters, setFilters] = useState({
        category: [],
        material: [],
        size: [],
    });
    useEffect(() => {
        setProducts(PRODUCTS_DATA);
        setFilteredProducts(PRODUCTS_DATA);
    }, [])

    // Handle checkbox change
    function handleCheckboxChange(filterType, value) {
        setFilters((prev) => {
            const updated = prev[filterType].includes(value)
                ? prev[filterType].filter((item) => item !== value)
                : [...prev[filterType], value];
            return { ...prev, [filterType]: updated };
        });
    };

    // Handle size button click
    function handleSizeClick(size) {
        setFilters((prev) => {
            const updated = prev.size.includes(size)
                ? prev.size.filter((s) => s !== size)
                : [...prev.size, size];
            return { ...prev, size: updated };
        });
    };

    function applyFilters() {
        const hasFilters =
            filters.category.length > 0 ||
            filters.material.length > 0 ||
            filters.size.length > 0;

        if (!hasFilters) {
            setFilteredProducts(products);
            return;
        }

        const filtered = products.filter((product) => {
            // Category match
            const categoryMatch =
                filters.category.length === 0 ||
                filters.category.includes(product.Category);

            // Material match
            const materialMatch =
                filters.material.length === 0 ||
                filters.material.includes(product.FabricType);

            // Size match
            const sizeMatch =
                filters.size.length === 0 ||
                (product.Sizes && filters.size.some(size => product.Sizes.includes(size)));

            return categoryMatch && materialMatch && sizeMatch;
        });

        setFilteredProducts(filtered);
    };

    const [material, setmaterial] = useState([]);

    function fetchmaterial() {
        db.collection("material").onSnapshot((succ) => {
            setmaterial(succ.docs);
        })
    }

    useEffect(() => {
        fetchmaterial();
    }, [])


    return (
        <>
            <div>
                <title>Wholesale Jeans Collection | Hack98</title>
                <meta name="description" content="Explore our collection of wholesale jeans and denims for men and boys. Premium quality, bulk orders, and distributor opportunities available." />
                <meta name="keywords" content="wholesale jeans collection, men’s jeans wholesale, boys jeans supplier, bulk denim jeans, premium denim wholesale, denim manufacturer India, wholesale jeans supplier, denim brand story, men’s jeans manufacturer, wholesale denim company, wholesale jeans supplier, premium denim jeans, men’s jeans wholesale, boys denim wholesale, bulk denim jeans,menswear near me, jeans near me, denims for men, denims for boys near me" />

                <meta property="og:title" content="Wholesale Jeans Collection | Hack98" />
                <meta property="og:site_name" content="Hack98" />
                <meta property="og:url" content="https://hack98.club/Products" />
                <meta property="og:description" content="Explore our collection of wholesale jeans and denims for men and boys. Premium quality, bulk orders, and distributor opportunities available." />
                <meta property="og:image" content="images /logoo.jpeg" />

                <meta name="twitter:card" content="app" />
                <meta name="twitter:site" content="hack98" />
                <meta name="twitter:description" content="Explore our collection of wholesale jeans and denims for men and boys. Premium quality, bulk orders, and distributor opportunities available." />
                <meta name="twitter:app:country" content="India" />

            </div >
            <div className="navbarrproducts">
                <Navbar />
            </div>
            <div className="container-fluid my-4">
                <div className="row">
                    <div className="col-md-2">
                        <h2 className="h6 fw-bold">Filters</h2>
                        <div className="mb-3">
                            <h6 className="fw-semibold">Category</h6>
                            {[
                                { label: "Men's Jeans", value: "men" },
                                { label: "Boys' Jeans", value: "boys" },
                            ].map((cat) => (
                                <div className="form-check" key={cat.value}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        onChange={() => handleCheckboxChange("category", cat.value)}
                                        checked={filters.category.includes(cat.value)}
                                    />
                                    <label className="form-check-label">{cat.label}</label>
                                </div>
                            ))}
                        </div>
                        <div className="mb-3">
                            <h6 className="fw-semibold">Material</h6>
                            {[
                                { label: "Denim", value: "Denim" },
                                { label: "Non Lycra", value: "Non Lycra" },
                                { label: "Lycra", value: "Lycra" },
                                { label: "Cotton", value: "Cotton" },
                            ].map((mat) => (
                                <div className="form-check" key={mat.value}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        onChange={() => handleCheckboxChange("material", mat.value)}
                                        checked={filters.material.includes(mat.value)}
                                    />
                                    <label className="form-check-label">{mat.label}</label>
                                </div>
                            ))}
                        </div>
                        <div className="mb-3">
                            <h6 className="fw-semibold">Size</h6>
                            <div className="d-flex flex-wrap gap-2">
                                {["24", "26", "28", "30", "32", "34", "36"].map((size) => (
                                    <button
                                        key={size}
                                        className={`btn btn-sm ${filters.size.includes(size)
                                            ? "btn-primary"
                                            : "btn-outline-secondary"
                                            }`}
                                        onClick={() => handleSizeClick(size)}
                                    >
                                        {size}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <button className="btn btn-primary w-100" onClick={applyFilters}>
                            Apply Filters
                        </button>
                    </div>
                    <div className="col-md-10">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h1 className="h4 fw-bold">Premium Denim Collection</h1>
                        </div>
                        <div className="row g-3">
                            {filteredProducts.map((row) => (
                                <div className="col-md-3 col-12 col-sm-6" key={row.id} onClick={() => navi("/Viewproduct?id=" + row.id)}>
                                    <div className="card cardd me-2 text-center shadow-sm">
                                        <img src={row.mainImage} alt={row.ProductName} className="imgg" />
                                        <div className="card-body">
                                            <h6 className="card-title">{row.ProductName}</h6>
                                            <p className="text-lead small">
                                                {row.Description?.slice(0, 30) + "..."}
                                            </p>
                                            <button className="btn btn-outline-primary btn-sm" onClick={() => navi("/Viewproduct?id=" + row.id)}>
                                                View
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row m-0 mt-4 align-items-center justify-content-center d-flex flex-wrap p-0 bottom-0 w-100">
                <Footer />
            </div>
        </>
    );
}